export default {
    action: 'Add macro-trend to innovation fields | Add macro-trends to innovation fields',
    title: 'Macro-trend',
    subtitle: 'Add to innovation fields',
    count: 'and one additional trend | and {count} additional trends',
    submit: 'Done',
    success: {
        single: 'The trend <strong>"{title}"</strong> was successfully added to an innovation field.',
        bulk: 'The selected trends were successfully added to the following innovation fields:'
    },
    error: 'An error has occured: <strong>"{title}"</strong>.'
}
